import { createAsyncTypes } from 'utils/ActionCreator'

const key = 'AwarenessCenter/Campaigns/AutonomousScheduler'

export const FETCH_AUTONOMOUS_SCHEDULE_ASYNC = createAsyncTypes('FETCH_AUTONOMOUS_SCHEDULE', key)
export const GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC = createAsyncTypes(
  'GET_GROUP_AUTONOMOUS_SCHEDULE',
  key
)
export const GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC = createAsyncTypes(
  'GET_GROUP_AUTONOMOUS_CONFIG_MEMBER',
  key
)
export const GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC = createAsyncTypes(
  'GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES',
  key
)
export const CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC = createAsyncTypes(
  'CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER',
  key
)
export const DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC = createAsyncTypes(
  'DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER',
  key
)
export const UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC = createAsyncTypes(
  'UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER',
  key
)
export const UPDATE_PARTICIPANTS_NUMBERS_ASYNC = createAsyncTypes(
  'UPDATE_PARTICIPANTS_NUMBERS',
  key
)
export const SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC = createAsyncTypes(
  'SAVE_GROUP_AUTONOMOUS_SCHEDULE',
  key
)
export const SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC = createAsyncTypes('SUBMIT_AUTONOMOUS_SCHEDULE', key)
export const GET_PARTICIPANTS_INFO_ASYNC = createAsyncTypes('GET_PARTICIPANTS_INFO', key)
export const FETCH_PARTICIPANTS_DATA_ASYNC = createAsyncTypes('FETCH_PARTICIPANTS_DATA', key)
export const GET_PARTICIPANTS_ASYNC = createAsyncTypes('GET_PARTICIPANTS', key)
export const SEARCH_PARTICIPANTS_INFO_ASYNC = createAsyncTypes('SEARCH_PARTICIPANTS_INFO', key)

export const CHANGE_PARTICIPANTS_SELECTION = `${key}/CHANGE_PARTICIPANTS_SELECTION`
export const CHANGE_PARTICIPANTS_TOTAL_SELECTION = `${key}/CHANGE_PARTICIPANTS_TOTAL_SELECTION`
export const CHANGE_EXCLUDE_FILTER = `${key}/CHANGE_EXCLUDE_FILTER`
export const CHANGE_MODAL_SEARCH = `${key}/CHANGE_MODAL_SEARCH`
export const CHANGE_PARTICIPANTS_MODAL_PAGE = `${key}/CHANGE_PARTICIPANTS_MODAL_PAGE`
export const CHANGE_MSP_PARTICIPANTS_MODAL_PAGE = `${key}/CHANGE_MSP_PARTICIPANTS_MODAL_PAGE`
export const CHANGE_SELECTION_DATA = `${key}/CHANGE_SELECTION_DATA`

export const MEMBERS_PER_PAGE = 7
export const CONFIG_CONFLICT = 'CONFIG_CONFLICT'
